// Setting keys
export const SETTING_KEY_P2P_DEVICE_NAME = "p2p_device_name";

// Configuration URI
export const configURIBase = "obsidian://setuplivesync?settings=";
export const configURIBaseQR = "obsidian://setuplivesync?settingsQR=";

// Database
export const SuffixDatabaseName = "-livesync-v2";
export const ExtraSuffixIndexedDB = "-indexeddb";
